export default "__VITE_ASSET__753827cc__"